/**
 * Small counts, in words — the copy vocabulary both first-party surfaces speak (issues #303,
 * #329; here since issue #387).
 *
 * The screens the canvases draw spell their counts: *"Everything I've saved about your family —
 * **sixteen** things in all"*, *"**Four** of you, and **one** invitation nobody has answered
 * yet"*. That is the product's voice rather than a formatting preference: the sentence is
 * Boone talking, and Boone does not say "4 of you".
 *
 * **One table because two would drift** — the argument `contextKinds.ts` won inside the
 * service, and the reason this left `apps/my.iamboone.app/src/words.ts` for this package the
 * day a second surface said the same sentences: that file's own header named the move
 * (*"if a second surface ever does, the move is the one `CONTEXT_KIND_HEADING` already
 * made"*), and Boone's app is that surface.
 */

/**
 * Where spelling stops.
 *
 * Twenty, because that is where written English stops spelling by default and because the two
 * numbers this actually renders — a roster bounded at six (#251) and a family's durable record,
 * which the canvas draws at sixteen — are both well inside it. Past it, digits: *"a hundred and
 * forty-three things in all"* is not warmer than "143", it is harder to read.
 */
const WORDS = [
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
  "twenty",
] as const;

/** `4` → `"four"`, `143` → `"143"`. Lowercase; the caller decides where a sentence starts. */
export function spell(n: number): string {
  return WORDS[n] ?? n.toLocaleString();
}

/** `"four of you"` → `"Four of you"`. */
export function sentenceCase(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
